// cspell:words xlarge
export enum CourierType {
  UBER = 'uber-direct',
  ROADIE = 'roadie-xlarge',
  ROADIE_HUGE = 'roadie-huge',
  PARTNER = 'resupply-partner',
}

// Donation display/behavior treats both Roadie variants identically. The captain courier tab
// and charity filters intentionally expose specific variants only (currently Roadie XLarge).
export const isRoadie = (courier?: string | null): boolean => courier === CourierType.ROADIE || courier === CourierType.ROADIE_HUGE;

export const COURIERS: { [key: string]: { value: string; name: string } } = {
  [CourierType.UBER]: {
    value: CourierType.UBER,
    name: 'Uber Direct',
  },
  [CourierType.ROADIE]: {
    value: CourierType.ROADIE,
    name: 'Roadie',
  },
  [CourierType.ROADIE_HUGE]: {
    value: CourierType.ROADIE_HUGE,
    name: 'Roadie',
  },
};
